import * as React from 'react';
import Select from 'react-select';
import { findCondition, startDeclaration } from '../../../../../../services/healix/reducer';
import { debounce } from 'lodash';
import { Alert, Button } from 'react-bootstrap';

export default class ConditionSearch extends React.Component<any, any> {
  public state = {
    condition: '',
    displayMinimum: false,
  };

  constructor(props) {
    super(props);

    this.search = debounce(this.search, 300);
  }

  private search = (query) => {
    if (query && query.length > 0 && query.length < 3) {
      this.setState({
        displayMinimum: true,
      });
    } else {
      this.setState({
        displayMinimum: false,
      });
    }
    this.props.dispatch(findCondition(query));
  }

  public componentDidUpdate(prevProps, prevState) {
    if (prevProps.conditionProps !== prevState.condition) {
      this.props.conditionChange(prevState.condition);
    }
  }

  private setCondition = (condition) => {
    this.setState({ condition },
      this.props.conditionChange(condition),
    );
  }

  private handleSubmit = () => {
    const { dispatch } = this.props;
    const { condition } = this.state;

    dispatch(startDeclaration(condition));
  }

  public render() {
    const { index, screening } = this.props;
    const { condition } = this.state;

    let isSurgical = false;

    screening.conditions.map((condition) => {
      if (condition.label === 'SURPROC') {
        isSurgical = true;
      }
    });

    return (
      <div className="search-conditions form-horizontal">
        <div className="form-group">
          {isSurgical ? (
            <div className="col-xs-12">
              <Alert bsStyle="danger">
                You have searched for a procedure or a surgery, please enter the name for the medical condition.
              </Alert>
            </div>
          ) : null}
          {screening.hasMisspelledConditions ? (
            <div className="col-xs-12">
              <Alert bsStyle="danger">
                No medical condition was found matching your search. However, did you mean:
              </Alert>
            </div>
          ) : null}
          {this.state.displayMinimum && (
            <div>
              <Alert bsStyle="danger">
                A minimum of three letters are required for the search.
              </Alert>
            </div>
          )}
          <label className="control-label col-sm-4 col-md-3">Search conditions</label>
          <div className="col-sm-8 col-md-7">
            <Select
              name={'conditions-search-' + index}
              cache="false"
              value={condition}
              isLoading={screening.isSearching}
              options={isSurgical ? [] : screening.conditions}
              placeholder="Enter Condition"
              filterOptions={false}
              onInputChange={this.search}
              onChange={this.setCondition}
            />
          </div>
          <div className="col-sm-12 col-md-2">
            <br className="visible-xs visible-sm"/>
            {condition && (
              <Button
                bsStyle="primary"
                disabled={screening.isSubmitting}
                onClick={this.handleSubmit}
                block={true}
              >
                Screen
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Healix/scenes/ConditionSearch/index.tsx